var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashBoxed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24919 1.13584C2.42821 1.13584 0.952006 2.61205 0.952006 4.43303V22.0662C0.952006 23.8872 2.4282 25.3634 4.24919 25.3634H22.0693C23.8903 25.3634 25.3665 23.8872 25.3665 22.0662V4.43303C25.3665 2.61204 23.8903 1.13584 22.0693 1.13584H4.24919Z",
    fill: "#FAFAFA",
    stroke: "#D0D8DC",
    strokeWidth: 0.732708
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8647 14.3886H19.35V16.2571H16.6162L16.2338 19H14.0735L14.4559 16.2571H11.6456L11.2632 19H9.12206L9.50441 16.2571H7V14.3886H9.75294L10.1544 11.6114H7.65V9.74286H10.4029L10.7853 7H12.9265L12.5441 9.74286H15.3544L15.7368 7H17.8779L17.4956 9.74286H19.9809L20 11.6114H17.2471L16.8647 14.3886ZM14.7044 14.3886L15.1059 11.6114H12.2956L11.8941 14.3886H14.7044Z",
    fill: "#7E898F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashBoxed);
export default __webpack_public_path__ + "static/media/HashBoxed.84e0d2435bb1dd93555d183031a96407.svg";
export { ForwardRef as ReactComponent };